module.exports = __webpack_public_path__ + "img/bottom.ced16893.png";